<template>
  <el-dialog
    ref="dialog"
    :key="index"
    class="ds-dialog dsf-dataview-dialog"
    v-bind.sync="$attrs"
    :class="elClass"
    :index="index"
    append-to-body
    v-on="$listeners"
  >
    <template v-slot:default>
      <div class="dsf-dataview-dialog-content" :style="wrapStyle">
        <div class="dsf-dataview-dialog-title" :style="titleStyle">
          <span>{{title}}</span>
          <i
            @click="close"
            class="iconfont icon-icon-close"
            :style="iconStyle"
          />
        </div>
        <DsfVirtualScroll :style="contentHeight">
          <slot></slot>
        </DsfVirtualScroll>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "DsfDataViewDialog",
  inheritAttrs: false,
  provide() {
    return {
      $dialog: this,
    };
  },
  props: {
    index: {
      type: String,
      default: "",
    },
    titleHeight: {
      type: String,
      default: "40",
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    dialogArgs: {
      type: Object,
      default() {
        return null;
      },
    },
    openerVm: {
      type: Object,
      default() {
        return null;
      },
    },
    //弹框样式配置
    styleConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    // 底部left居左,center居中,right居右
    footerAlign: {
      type: String,
      required: false,
    },
    //内容区域是否存在边框线
    conentBorder: {
      type: Boolean,
      default: false,
    },
    allowDraggable: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: "300px",
    },
     title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      destoryElDialog: false,
    };
  },
  created() {
    this.currentView = null;
  },
  computed: {
    wrapStyle() {
      let {
        background,
        borderWidth,
        borderColor,
        borderRadius,
      } = this.styleConfig;

      let backgroundStyle = dsf.dataview.utils.colorFormatCoexist(background);

      borderRadius = dsf.dataview.utils.transformPx(borderRadius);
      borderWidth = dsf.dataview.utils.transformPx(borderWidth);
      let border = `${borderWidth} solid ${borderColor}`;
      return {
        border,
        ...backgroundStyle,
        "border-radius": borderRadius,
      };
    },
    contentHeight() {
      let { padding } = this.styleConfig;
      padding = dsf.dataview.utils.transformArrayPx(padding);
      let height = parseInt(this.height);
      return {
        padding,
        height: height + "px",
      };
    },
    titleStyle() {
      let {
        titleHeight,
        fontFamily,
        color,
        fontSize,
        algin,
        titlePadding,
      } = this.styleConfig;

      titleHeight = parseInt(titleHeight) || 40;

      fontSize = dsf.dataview.utils.transformPx(fontSize);

      let padding = dsf.dataview.utils.transformArrayPx(titlePadding);
      return {
        padding,
        color,
        height: titleHeight + "px",
        "font-size": fontSize,
        "font-family": fontFamily,
      };
    },
    iconStyle() {
      let { iconColor: color, iconSize } = this.styleConfig;
      let fontSize = dsf.dataview.utils.transformPx(iconSize);
      return {
        color,
        "font-size": fontSize,
      };
    },
    elClass() {
      let res = [];
      let align =
        this.footerAlign ||
        dsf.config.setting_public_default_dialog_footer_align;
      if (align && align != "right") {
        res.push("dialog-footer-" + align);
      }
      if (this.$attrs["show-close"]) {
        res.push("show-close");
      }
      if (this.noTitle) {
        res.push("no-title");
      }
      if (this.options.className) {
        res.push(this.options.className);
      }
      if (this.conentBorder) {
        res.push("ds-dialog-content-border");
      }
      if (this.allowDraggable) {
        res.push("ds-dialog-allow-draggable");
      }
      return res;
    },
  },
  methods: {
    close() {
      this.$refs.dialog.handleClose();
    },

    dialogSure() {
      this.$emit("dialog-yes");
    },
    updateElInfo() {
      this.windowWidth = document.documentElement.clientWidth;
      this.windowHeight = document.documentElement.clientHeight;
      let boundingClientRect = this.dialogEl[0].getBoundingClientRect();
      this.elTop = boundingClientRect.top;
      this.elRight = boundingClientRect.right;
      this.elBottom = boundingClientRect.bottom;
      this.elLeft = boundingClientRect.left;
      this.elWidth = this.dialogEl.width();
      this.elHeight = this.dialogEl.height();
      this.elBodyHeight = this.dialogEl.find(".el-dialog__body").height();
      if (this.isMarginCenter == undefined) this.isMarginCenter = true;
    },
    draggable({ disable } = {}) {
      if (disable) return;
      this.headEl = this.dialogEl.find(".dsf-dataview-dialog-title");
     
      this.headEl.get(0).addEventListener("mousedown", this.draggableMouseDown);
    },
    dragSize({ disable } = {}) {
      this.sizeHandleEl = $('<div class="el-dialog__size-handle"></div>');
      let sizeHandleEl = this.sizeHandleEl;
      this.dialogEl.append(sizeHandleEl);
      sizeHandleEl.get(0).addEventListener("mousedown", this.dragSizeMouseDown);
    },
    draggableMouseDown(e) {
      this.headEl.css({
        userSelect: "none",
      });
      this.updateElInfo();
      this.moveType = "position";
      this.sizeDownX = e.pageX;
      this.sizeDownY = e.pageY;
      this.isSizeDown = true;
    },
    dragSizeMouseDown(e) {
      this.updateElInfo();
      this.moveType = "size";
      this.sizeDownX = e.pageX;
      this.sizeDownY = e.pageY;
      this.isSizeDown = true;
    },
    bodyMousemove(e) {
      if (!this.moveType) {
        return;
      }
      let distanceX = e.pageX - this.sizeDownX;
      let distanceY = e.pageY - this.sizeDownY;
      if (
        this.moveType == "size" &&
        (this.isSizeDown && this.elWidth, this.elBodyHeight)
      ) {
        if (this.isMarginCenter) {
          distanceX = distanceX * 2;
        }
        let width = this.elWidth + distanceX;
        let height = this.elBodyHeight + distanceY;
        if (width > this.windowWidth) {
          width = this.windowWidth;
        }
        if (height > this.windowHeight) {
          height = this.windowHeight;
        }
        this.dialogEl.width(width);
        this.dialogEl.find(".el-dialog__body").height(height);
      } else if (this.moveType == "position") {
        let left = this.elLeft + distanceX;
        let top = this.elTop + distanceY;

        if (left > this.windowWidth - this.elWidth) {
          left = this.windowWidth - this.elWidth;
        }
        if (top > this.windowHeight - this.elHeight) {
          top = this.windowHeight - this.elHeight;
        }
        if (left < 0) {
          left = 0;
        }
        if (top < 0) {
          top = 0;
        }
        this.isMarginCenter = false;
        dsf.closeAllPopover();
        this.dialogEl.css({
          left,
          top,
          margin: 0,
        });
      }
    },
    bodyMouseup(e) {
      this.isSizeDown = false;
      this.moveType = null;
      this.elWidth = null;
      this.elHeight = null;
      this.elBodyHeight = null;
      this.headEl.css({
        userSelect: "text",
      });
    },
    destroyOnClose() {
      this.$refs.dialog.key++;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.bodyMousemove = this.bodyMousemove.bind(this);
      this.bodyMouseup = this.bodyMouseup.bind(this);
      document.addEventListener("mousemove", this.bodyMousemove);
      document.addEventListener("mouseup", this.bodyMouseup);
      this.dialogEl = $(this.$refs.dialog.$el).find(".el-dialog");
      this.draggable({ disable: !this.allowDraggable });
    });

    // this.dragSize();
  },
  beforeDestroy() {
    if (this.sizeHandleEl && this.sizeHandleEl.length) {
      this.sizeHandleEl
        .get(0)
        .removeEventListener("mousedown", this.dragSizeMouseDown);
      this.sizeHandleEl.remove();
    }
    if (this.headEl && this.headEl.length) {
      this.headEl
        .get(0)
        .removeEventListener("mousedown", this.draggableMouseDown);
    }
    this.currentView = null;
    this.destoryElDialog = true;
  },
  destroyed() {
    document.removeEventListener("mousemove", this.bodyMousemove);
    document.removeEventListener("mouseup", this.bodyMouseup);
    this.draggable({ disable: true });
  },
};
</script>
